import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (data) => {
  return await dponetAPI.post('/payment_links', data)
}

const plans = {
  create,
}

export default plans
